module.exports = __webpack_public_path__ + "img/wz-8-5-1.dee7b5eb.jpg";